export const FONT_SIZE = {
	SMALL: "SMALL",
	STANDARD: "STANDARD",
	LARGE: "LARGE",
	EXTRA_LARGE: "EXTRA_LARGE",
};
